import header from './header.component';

export default angular
  .module('fizyweb.paycell.header', [])
  .component('fizyPaycellHeader', header).name;



// WEBPACK FOOTER //
// src/app/components/header/header.module.ts